/* eslint-disable max-lines */
import Activity from "@/pages/activity";
import AfterPay from "@/pages/after-pay";
import AssistantConfirmOrder from "@/pages/ai-assistant/confirmOrder";
import Index from "@/pages/AppContainer";
import BrandMaterial from "@/pages/brandMaterial";
import CartShare from "@/pages/cart/share";
import ChangePhone from "@/pages/change-phone";
import CommentList from "@/pages/comment-list";
import CouponList from "@/pages/CouponList";
import DailyReward from "@/pages/daily-reward";
import CustomerReward from "@/pages/daily-reward/customerReward";
import RedPacketDetail from "@/pages/daily-reward/redPacketDetail";
import MyReward from "@/pages/daily-reward/reward";
import RewardOrder from "@/pages/daily-reward/rewardOrder";
import Decorate from "@/pages/decorate/container";
import DispatchTask from "@/pages/dispatch-task";
import EnticeSearch from "@/pages/enticeSearch/searchContainer";
import Focus from "@/pages/Focus";
import FollowProduct from "@/pages/follow-product";
import HideSetting from "@/pages/hide-setting";
import HideSettingSearch from "@/pages/hide-setting/search";
import HighCommission from "@/pages/HighCommission";
import Home from "@/pages/home/index";
import ImageSearch from "@/pages/imageSearch";
import JoinOrderNX from "@/pages/join-order-nx";
import JoinBill from "@/pages/JointBill/JointBill";
import GoodLivePreheat from "@/pages/live/goods/live-preheat";
import Logistics from "@/pages/logistics";
import Logout from "@/pages/logout";
import MarketContainer from "@/pages/MarketContainer";
import MarketSearch from "@/pages/MarketSearch";
import MaterialVideoList from "@/pages/material-video-list";
import Material from "@/pages/material/container";
import MediaList from "@/pages/media-list";
import AftersaleApp from "@/pages/MicroAppContainer/modules/aftersaleApp";
import CschatApp from "@/pages/MicroAppContainer/modules/cschatApp";
import MicroAppDetail from "@/pages/MicroAppDetail";
import My from "@/pages/my";
import MySetting from "@/pages/my-setting";
import NewPerson from "@/pages/new-person";
import Personal from "@/pages/personal";
import PersonalSetting from "@/pages/personal-setting";
import ProductDetailMaterial from "@/pages/product-detail/material";
import ProductDetail from "@/pages/product-detail/normal";
import SizeInfoPage from "@/pages/product-detail/size-info";
import VideoCardList from "@/pages/product-detail/video-card-list";
import PromoteDetail from "@/pages/promote-detail/container";
import PromoteContainer from "@/pages/promote/container";
import QuestionsAnswers from "@/pages/questions-answers";
import RankScale from "@/pages/rank-scale";
import RankAll from "@/pages/rank-scale/RankAll";
import RealShotList from "@/pages/real-shot-list/index";
import RecommendList from "@/pages/recommend-list";
import RewardGiftActivity from "@/pages/reward-gift-activity";
import RewardGiftDetail from "@/pages/reward-gift-detail";
import RewardCenter from "@/pages/rewardCenter";
import RewardCenterDetail from "@/pages/rewardCenter/detail";
import RewardCenterDetailDistributor from "@/pages/rewardCenter/distributor";
import RewardCenterFillAddress from "@/pages/rewardCenter/fillAddress";
import RewardCenterLanding from "@/pages/rewardCenter/landing";
import RewardSearch from "@/pages/rewardCenter/search";
import RmsActivity from "@/pages/rms-activity";
import SaleCalendar from "@/pages/sale-calendar";
import SecKill from "@/pages/SecKill";
import SelectiveForward from "@/pages/selective-forward";
import SelectivePosters from "@/pages/selective-posters";
import ShareSetting from "@/pages/share-setting";
import ShopInfo from "@/pages/ShopInfo";
import ShopList from "@/pages/ShopList";
import ShowImages from "@/pages/ShowImages";
import TopList from "@/pages/TopList";
import TradeSnapshotDetail from "@/pages/trade-snapshot/detail";
import TradeSnapshotList from "@/pages/trade-snapshot/list";
import UserTrack from "@/pages/userTrack";
import VideoShare from "@/pages/videoSharer";
import HistoryData from "@/pages/videoSharer/historyData";
import PerformanceBoard from "@/pages/videoSharer/performanceBoard";
import VideoSharerInstruction from "@/pages/videoSharer/VideoSharerInstruction";
import Achievement from "@/pages/year-end-bonus/achievement";
import BrandBole from "@/pages/year-end-bonus/brand-bole";
import YearEndBonusDetail from "@/pages/year-end-bonus/detail";
import Empowerment from "@/pages/year-end-bonus/empowerment";
import GoldMedal from "@/pages/year-end-bonus/gold-medal";
import YearEndBonusLanding from "@/pages/year-end-bonus/landing";
import YearEndBonusRank from "@/pages/year-end-bonus/rank";
import YearEndBonusSearch from "@/pages/year-end-bonus/search";
import YouxueCalendarPage from "@/pages/youxue/calendar";
import YouxueHistoryPage from "@/pages/youxue/history";
import YouxueInvitePage from "@/pages/youxue/invite";
import YouxueSignUpPage from "@/pages/youxue/sign-up";
import YouxueTravelConfirm from "@/pages/youxue/travel-confirm";
import React, { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import ErrorBoundary from "../pages/ErrorBoundary";
import { KeepAliveContainer, Layout, lazyLoad, RouteName, TrackDataComp } from "./extra";

// 自定义路由实例
type Route = {
  path: string; // 路由路径
  name: RouteName; // 路由名称
  pageName?: string; // 页面名称
  element?: React.ReactNode; // 入口react节点，lazy 为true时无用
  lazy?: boolean; // 是否懒加载
  lazyPath?: string; // 页面路径, lazy为true时必选
  to?: string; // 重定向，如果有这个属性，就会重定向到这个路由
  title?: string; // 页面标题
  KeepAlive?: boolean; // 是否缓存页面
  keepAliveList?: string[]; // 缓存页面的key,会从路由上去取
};

// 新增路由，先在extra的Route中定义，然后在下面的routesList中添加
// 二级路由
export const routesList: Array<Route> = [
  {
    path: "/mx-shop-micro",
    name: RouteName.Index,
    element: <Index />,
    title: "会场",
  },
  {
    path: "/mx-shop-micro/activity/:activityId",
    name: RouteName.Activity,
    pageName: "档期详情",
    KeepAlive: true,
    keepAliveList: ["activityId", "isShowAll", "type"],
    element: <Activity />,
    // lazy: true,
    // lazyPath: "activity/index",
  },
  {
    path: "/mx-shop-micro/decorate",
    name: RouteName.Decorate,
    pageName: "店铺详情",
    KeepAlive: true,
    keepAliveList: ["merchantShopCode"],
    element: <Decorate />,
  },
  {
    path: "/mx-shop-micro/micro-app-detail",
    name: RouteName.MicroAppDetail,
    element: <MicroAppDetail />,
    to: "/",
  },
  {
    path: "/mx-shop-micro/joint-bill",
    name: RouteName.JoinBill,
    KeepAlive: true,
    keepAliveList: ["couponId", "voucherNo", "awdInstanceId"],
    element: <JoinBill />,
  },
  {
    path: "/mx-shop-micro/seckill",
    name: RouteName.SecKill,
    element: <SecKill />,
  },
  {
    path: "/mx-shop-micro/decorate/coupon",
    name: RouteName.CouponList,
    element: <CouponList />,
  },
  {
    path: "/mx-shop-micro/decorate/toplist",
    name: RouteName.TopList,
    element: <TopList />,
  },
  {
    path: "/mx-shop-micro/logistics",
    name: RouteName.Logistics,
    KeepAlive: true,
    keepAliveList: ["timestamp"],
    element: <Logistics />,
  },
  {
    //微应用路由
    path: "/",
    name: RouteName.MicroAppDetail,
    element: <MicroAppDetail />,
  },
  {
    path: "/mx-shop-micro/decorate/profit",
    name: RouteName.HighCommission,
    element: <HighCommission />,
  },
  {
    path: "/mx-shop-micro/decorate/categroy",
    name: RouteName.HighCommission,
    element: <HighCommission />,
  },
  {
    path: "/mx-shop-micro/decorate/seckill",
    name: RouteName.SecKill,
    KeepAlive: true,
    keepAliveList: ["merchantShopCode", "componentCode"],
    element: <SecKill />,
  },
  {
    path: "/mx-shop-micro/shop/info",
    name: RouteName.ShopInfo,
    element: <ShopInfo />,
  },
  {
    path: "/mx-shop-micro/show-images",
    name: RouteName.ShowImages,
    element: <ShowImages />,
  },
  {
    path: "/mx-shop-micro/market",
    name: RouteName.Market,
    element: <MarketContainer />,
  },
  {
    path: "/mx-shop-micro/market/marketSearch",
    name: RouteName.MarketSearch,
    element: <MarketSearch />,
    KeepAlive: true,
    keepAliveList: ["merchantShopCode"],
  },
  {
    path: "/mx-shop-micro/market/marketFocus",
    name: RouteName.Focus,
    element: <Focus />,
  },
  {
    path: "/mx-shop-micro/shopList",
    name: RouteName.ShopList,
    element: <ShopList />,
  },
  {
    path: "/mx-shop-micro/promote", //逛一逛
    name: RouteName.Promote,
    element: <PromoteContainer />,
  },
  {
    path: "/mx-shop-micro/real-shot-list", //种草专区
    name: RouteName.RealShotList,
    element: <RealShotList />,
    KeepAlive: true,
    keepAliveList: ["objectIds", "baseProductIds"],
  },
  {
    path: "/mx-shop-micro/promoteDetail",
    name: RouteName.PromoteDetail,
    element: <PromoteDetail />,
  },
  {
    path: "/mx-shop-micro/recommendList",
    name: RouteName.RecommendList,
    element: <RecommendList />,
  },
  {
    path: "/mx-shop-micro/material-video-list", //素材视频大卡页
    name: RouteName.MaterialVideoList,
    element: <MaterialVideoList />,
  },
  {
    path: "/mx-shop-micro/enticeSearch",
    name: RouteName.EnticeSearch,
    element: <EnticeSearch />,
  },
  {
    path: "/mx-shop-micro/video-share",
    name: RouteName.VideoShare,
    KeepAlive: true,
    element: <VideoShare />,
  },
  {
    path: "/mx-shop-micro/my",
    name: RouteName.My,
    KeepAlive: true,
    element: <My />,
    // lazy: true,
    // lazyPath: "my/index",
  },
  {
    path: "/mx-shop-micro/sub-setting",
    name: RouteName.MySetting,
    element: <MySetting />,
  },
  {
    path: "/mx-shop-micro/personal",
    name: RouteName.Personal,
    KeepAlive: true,
    element: <Personal />,
  },
  {
    path: "/mx-shop-micro/setting",
    name: RouteName.PersonalSetting,
    element: <PersonalSetting />,
  },
  {
    path: "/mx-shop-micro/track",
    name: RouteName.UserTrack,
    element: <UserTrack />,
  },
  {
    path: "/mx-shop-micro/home",
    name: RouteName.Home,
    KeepAlive: true,
    element: <Home />,
  },
  {
    path: "/mx-shop-micro/video-sharer-instruction",
    name: RouteName.VideoSharerInstruction,
    element: <VideoSharerInstruction />,
  },
  {
    path: "/mx-shop-micro/new-person",
    name: RouteName.NewPerson,
    KeepAlive: true,
    element: <NewPerson />,
  },
  {
    path: "/mx-shop-micro/logout",
    name: RouteName.Logout,
    element: <Logout />,
  },
  {
    path: "/mx-shop-micro/material",
    name: RouteName.Material,
    element: <Material />,
  },
  {
    path: "/mx-shop-micro/video-share/performanceBoard",
    name: RouteName.PerformanceBoard,
    element: <PerformanceBoard />,
  },
  {
    path: "/mx-shop-micro/video-share/historyData",
    name: RouteName.HistoryData,
    element: <HistoryData />,
  },
  {
    path: "/mx-shop-micro/selective-forward",
    name: RouteName.SelectiveForward,
    KeepAlive: true,
    keepAliveList: ["activityIdList", "brandIds", "categoryIdList", "shopCodes", "timestamp"],
    element: <SelectiveForward />,
  },
  {
    path: "/mx-shop-micro/selective-posters",
    name: RouteName.SelectivePosters,
    element: <SelectivePosters />,
  },
  {
    path: "/mx-shop-micro/share-setting",
    name: RouteName.ShareSetting,
    KeepAlive: true,
    element: <ShareSetting />,
  },
  {
    path: "/mx-shop-micro/search",
    name: RouteName.Search,
    lazy: true,
    lazyPath: "search/index",
    KeepAlive: true,
    keepAliveList: ["searchWords", "timestamp"],
  },
  {
    path: "/mx-shop-micro/dispatch-task",
    name: RouteName.DispatchTask,
    KeepAlive: true,
    element: <DispatchTask />,
  },
  {
    path: "/mx-shop-micro/reward-center",
    name: RouteName.RewardCenter,
    KeepAlive: true,
    element: <RewardCenter />,
  },
  {
    path: "/mx-shop-micro/reward-center/detail",
    name: RouteName.RewardCenterDetail,
    element: <RewardCenterDetail />,
  },
  {
    path: "/mx-shop-micro/reward-center/detail/distributor",
    name: RouteName.RewardCenterDetailDistributor,
    element: <RewardCenterDetailDistributor />,
  },
  {
    path: "/mx-shop-micro/reward-center/fill-address",
    name: RouteName.RewardCenterFillAddress,
    element: <RewardCenterFillAddress />,
  },
  {
    path: "/mx-shop-micro/reward-center/landing",
    name: RouteName.RewardCenterLanding,
    element: <RewardCenterLanding />,
  },
  {
    path: "/mx-shop-micro/reward-search",
    name: RouteName.RewardSearch,
    element: <RewardSearch />,
  },
  {
    path: "/mx-shop-micro/aftersale/*",
    name: RouteName.AftersaleApp,
    element: <AftersaleApp />,
  },
  {
    path: "/mx-shop-micro/cschat/*",
    name: RouteName.CschatApp,
    element: <CschatApp />,
  },
  {
    path: "/mx-shop-micro/yx/calendar",
    name: RouteName.YXCalendar,
    element: <YouxueCalendarPage />,
  },
  {
    path: "/mx-shop-micro/yx/invite",
    name: RouteName.YXInvite,
    element: <YouxueInvitePage />,
  },
  {
    path: "/mx-shop-micro/yx/signup",
    name: RouteName.YXSignUp,
    element: <YouxueSignUpPage />,
  },
  {
    path: "/mx-shop-micro/yx/travelConfirm",
    name: RouteName.YXTravelConfirm,
    element: <YouxueTravelConfirm />,
  },
  {
    path: "/mx-shop-micro/yx/history",
    name: RouteName.YXHistory,
    element: <YouxueHistoryPage />,
  },
  {
    path: "/mx-shop-micro/hide-setting",
    name: RouteName.HideSetting,
    element: <HideSetting />,
  },
  {
    path: "/mx-shop-micro/follow-product",
    name: RouteName.FollowProduct,
    element: <FollowProduct />,
  },
  {
    path: "/mx-shop-micro/ai-assistant/confirm-order",
    name: RouteName.AssistantConfirmOrder,
    element: <AssistantConfirmOrder />,
  },
  {
    path: "/mx-shop-micro/hide-setting/search",
    name: RouteName.HideSettingSearch,
    element: <HideSettingSearch />,
  },
  {
    path: "/mx-shop-micro/sale-calendar",
    name: RouteName.SaleCalendar,
    KeepAlive: true,
    element: <SaleCalendar />,
  },
  {
    path: "/mx-shop-micro/daily-reward",
    name: RouteName.DailyReward,
    KeepAlive: true,
    element: <DailyReward />,
    // lazy: true,
    // lazyPath: "daily-reward/index",
  },
  {
    path: "/mx-shop-micro/reward",
    name: RouteName.MyReward,
    KeepAlive: false,
    keepAliveList: ["timestamp"],
    element: <MyReward />,
  },
  {
    path: "/mx-shop-micro/reward-order",
    name: RouteName.RewardOrder,
    element: <RewardOrder />,
  },
  {
    path: "/mx-shop-micro/customer-reward",
    name: RouteName.CustomerReward,
    KeepAlive: true,
    element: <CustomerReward />,
  },
  {
    path: "/mx-shop-micro/redPacket-detail",
    name: RouteName.RedPacketDetail,
    element: <RedPacketDetail />,
  },
  {
    path: "/mx-shop-micro/product",
    name: RouteName.ProductDetail,
    pageName: "商品详情",
    KeepAlive: true,
    keepAliveList: ["activitySpuId", "activityId", "selectSkuId", "productId"],
    element: <ProductDetail />,
    // lazy: true,
    // lazyPath: "product-detail/normal",
  },
  {
    path: "/mx-shop-micro/comment-list",
    name: RouteName.CommentList,
    KeepAlive: false,
    element: <CommentList />,
  },
  {
    path: "/mx-shop-micro/media-list",
    name: RouteName.MediaList,
    KeepAlive: false,
    element: <MediaList />,
  },
  {
    // 素材商品详情页
    path: "/mx-shop-micro/product-material",
    name: RouteName.ProductDetailMaterial,
    element: <ProductDetailMaterial />,
  },
  {
    path: "/mx-shop-micro/image-search",
    name: RouteName.ImageSearch,
    KeepAlive: true,
    element: <ImageSearch />,
    keepAliveList: ["picturePath"],
  },
  {
    path: "/mx-shop-micro/year-end-bonus/brand-bole",
    name: RouteName.BrandBole,
    element: <BrandBole />,
    KeepAlive: true,
    keepAliveList: ["activityCode"],
  },
  {
    path: "/mx-shop-micro/year-end-bonus/gold-medal",
    name: RouteName.GoldMedal,
    element: <GoldMedal />,
    KeepAlive: true,
    keepAliveList: ["activityCode"],
  },
  {
    path: "/mx-shop-micro/year-end-bonus/achievement",
    name: RouteName.Achievement,
    element: <Achievement />,
    KeepAlive: true,
    keepAliveList: ["activityCode"],
  },
  {
    path: "/mx-shop-micro/year-end-bonus/landing",
    name: RouteName.YearEndBonusLanding,
    element: <YearEndBonusLanding />,
    KeepAlive: true,
    keepAliveList: ["brandActivityCode"],
  },
  {
    path: "/mx-shop-micro/year-end-bonus/search",
    name: RouteName.YearEndBonusSearch,
    element: <YearEndBonusSearch />,
    KeepAlive: true,
    keepAliveList: ["activityCode"],
  },
  {
    path: "/mx-shop-micro/year-end-bonus/detail",
    name: RouteName.YearEndBonusDetail,
    element: <YearEndBonusDetail />,
    KeepAlive: true,
    keepAliveList: ["brandActivityCode"],
  },
  {
    path: "/mx-shop-micro/rms-activity",
    name: RouteName.RmsActivity,
    element: <RmsActivity />,
    KeepAlive: true,
    keepAliveList: ["planId"],
  },
  {
    path: "/mx-shop-micro/year-end-bonus/rank",
    name: RouteName.YearEndBonusRank,
    element: <YearEndBonusRank />,
  },
  {
    path: "/mx-shop-micro/year-end-bonus/empowerment",
    name: RouteName.Empowerment,
    element: <Empowerment />,
  },
  {
    path: "/mx-shop-micro/after-pay",
    name: RouteName.AfterPay,
    element: <AfterPay />,
  },
  {
    path: "/mx-shop-micro/brand-material",
    name: RouteName.BrandMaterial,
    element: <BrandMaterial />,
  },
  {
    path: "/mx-shop-micro/trade-snapshot/list",
    name: RouteName.TradeSnapshotList,
    element: <TradeSnapshotList />,
  },
  {
    path: "/mx-shop-micro/trade-snapshot/detail",
    name: RouteName.TradeSnapshotDetail,
    element: <TradeSnapshotDetail />,
  },
  {
    path: "/mx-shop-micro/join-order-nx",
    name: RouteName.JoinOrderNX,
    element: <JoinOrderNX />,
  },
  {
    path: "/mx-shop-micro/rank-scale",
    name: RouteName.RankScale,
    element: <RankScale />,
  },
  {
    path: "/mx-shop-micro/rank-all",
    name: RouteName.RankAll,
    KeepAlive: true,

    element: <RankAll />,
  },
  {
    path: "/mx-shop-micro/questions-answers",
    name: RouteName.QuestionsAnswers,
    element: <QuestionsAnswers />,
  },
  {
    path: "/mx-shop-micro/gift-pay-status",
    name: RouteName.GiftPayStatus,
    lazy: true,
    lazyPath: "send-gift/gift-pay-status/index",
    // element: <GiftPayStatus />,
  },
  {
    path: "/mx-shop-micro/gift-list",
    name: RouteName.GiftList,
    lazy: true,
    lazyPath: "send-gift/gift-list/index",
    // element: <GiftList />,
  },
  {
    path: "/mx-shop-micro/gift-notice",
    name: RouteName.GiftNotice,
    lazy: true,
    lazyPath: "send-gift/gift-notice/index",
    // element: <GiftNotice />,
  },
  {
    path: "/mx-shop-micro/change-phone",
    name: RouteName.ChangePhone,
    element: <ChangePhone />,
  },
  {
    path: "/mx-shop-micro/reward-gift-detail",
    name: RouteName.RewardGiftDetail,
    element: <RewardGiftDetail />,
  },
  {
    path: "/mx-shop-micro/reward-gift-activity",
    name: RouteName.RewardGiftActivity,
    element: <RewardGiftActivity />,
  },
  {
    //商品直播预告
    path: "/mx-shop-micro/goods-live-preheat",
    name: RouteName.GoodsLivePreheat,
    element: <GoodLivePreheat />,
  },
  {
    path: "/mx-shop-micro/size-info", // 更多尺码参考
    name: RouteName.SizeInfo,
    lazy: true,
    lazyPath: "product-detail/size-info",
  },
  {
    path: "/mx-shop-micro/cart-share",
    name: RouteName.CartShare,
    element: <CartShare />,
  },
  {
    path: "/mx-shop-micro/shop-auth-guide",
    name: RouteName.ShopAuthGuide,
    lazy: true,
    lazyPath: "shop-auth-guide/index",
  },
  {
    path: "/mx-shop-micro/nx-cancel",
    name: RouteName.NXCancel,
    lazy: true,
    lazyPath: "after-sales/NXCancel/index",
  },
  {
    path: "/mx-shop-micro/year-end-bonus/best-new-people",
    name: RouteName.BestNewPeople,
    lazy: true,
    lazyPath: "year-end-bonus/best-new-people/index",
  },
  {
    path: "/mx-shop-micro/year-end-bonus/supper-navigator",
    name: RouteName.SupperNavigator,
    lazy: true,
    lazyPath: "year-end-bonus/supper-navigator/index",
  },
  {
    path: "/mx-shop-micro/year-end-bonus/full-rank",
    name: RouteName.FullRank,
    lazy: true,
    lazyPath: "year-end-bonus/full-rank/index",
  },
  {
    path: "/mx-shop-micro/wechat-bind",
    name: RouteName.WechatBind,
    lazy: true,
    lazyPath: "customer-service/wechat-bind/index",
  },
  {
    path: "/mx-shop-micro/video-card-list",
    name: RouteName.VideoCardList,
    element: <VideoCardList />,
    KeepAlive: true,
    keepAliveList: ["activitySpuId", "vcScene"],
  },
  {
    path: "/mx-shop-micro/open-app",
    name: RouteName.OpenApp,
    lazy: true,
    lazyPath: "open-app/index",
  },
];

const children = routesList.map(item => {
  if (item.to) {
    return {
      path: item.path,
      element: <Navigate replace to={item.to}></Navigate>,
      errorElement: <ErrorBoundary />,
    };
  }
  if (item.lazy && item.lazyPath) {
    const LazyComponent = lazy(() => import(`@/pages/${item.lazyPath}`));
    return {
      path: item.path,
      element: item.KeepAlive ? (
        <KeepAliveContainer
          element={lazyLoad(LazyComponent)}
          name={item.name}
          keepAliveList={item.keepAliveList}
        />
      ) : (
        <TrackDataComp>{lazyLoad(LazyComponent)}</TrackDataComp>
      ),
      errorElement: <ErrorBoundary />,
    };
  }
  if (item.KeepAlive) {
    return {
      path: item.path,
      element: (
        <KeepAliveContainer
          element={item.element}
          name={item.name}
          keepAliveList={item.keepAliveList}
        />
      ),
      errorElement: <ErrorBoundary />,
    };
  }
  return {
    path: item.path,
    element: <TrackDataComp>{item.element}</TrackDataComp>,
    errorElement: <ErrorBoundary />,
  };
});

// 一级路由
const routes = [
  {
    path: "/",
    element: <Layout />,
    children,
  },
];

const router = createBrowserRouter(routes, {
  future: {
    v7_relativeSplatPath: true,
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true,
  },
});

export default router;
